<template>
  <!-- <v-container
    id="fondo"
    fluid
    style="height:100%"
    class="d-flex justify-center align-center fill-height"
  >
    <v-row align="center" justify="center">
      <v-col
        cols="12"
        sm="12"
        md="10"
        class="d-flex justify-center align-center"
      >
        <v-card class="elevation-24" min-width="340">
          <v-toolbar color="primary" dark flat>
            <v-icon>mdi-lock</v-icon>
            <v-toolbar-title
              class="text-uppercase font-weight-bold  text-center mx-auto text-uppercase"
              >{{ $t("login.v-tool-bar-title") }}</v-toolbar-title
            >
          </v-toolbar>

          <v-card v-if="errors && errors.length">
            <v-card-text
              class="#730D0B--text"
              v-for="(err, index) of errors"
              :key="index"
              >{{ err }}</v-card-text
            >
          </v-card>
          <v-card-text>
            <v-form dark ref="form" v-model="valid" lazy-validation>
              <v-text-field
                :label="$t('login.label-email')"
                name="email"
                v-model="loginForm.email"
                prepend-icon="mdi-at"
                type="email"
                :rules="emailRules"
              />
              <v-text-field
                v-on:keyup.enter="onSubmit"
                id="password"
                :label="$t('login.label-password')"
                name="password"
                v-model="loginForm.password"
                prepend-icon="mdi-lock"
                type="password"
                :rules="passwordRules"
              />
              <div class="d-flex justify-end">
                <v-btn :disabled="!valid" @click="onSubmit" color="primary"
                  >{{ $t("login.v-btn-login") }}
                  <v-icon>mdi-login</v-icon></v-btn
                >
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container> -->
  <v-container id="login" class="fill-height justify-center" tag="section">
    <v-row justify="center" align="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          max-width="100%"
          width="400"
          class="px-5 mt-12 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h2 class="font-weight-bold mb-2">
                {{ $t("login.title") }}
              </h2>
            </div>
          </template>

          <v-card-text class="text-center">
            <v-form dark ref="form" v-model="valid" lazy-validation>
              <v-text-field
                color="primary"
                :label="$t('login.email')"
                prepend-icon="mdi-email"
                v-model="loginForm.email"
                :rules="emailRules"
              />

              <v-text-field
                v-on:keyup="capson"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                class="mb-8"
                color="primary"
                :rules="passwordRules"
                :label="$t('login.password')"
                v-model="loginForm.password"
                :type="showPassword ? 'text' : 'password'"
                :hint="this.capsHint"
                prepend-icon="mdi-lock-outline"
              />
              <v-card-actions class="d-flex flex-column">
                <v-btn
                  :disabled="!valid"
                  @click="onSubmit"
                  x-large
                  width="200"
                  color="primary"
                  class="  mt-2  white--text"
                >
                  {{ $t("login.loginbtn") }}
                  <v-icon>mdi-login</v-icon> </v-btn
                ><v-spacer></v-spacer>
                <v-btn @click="dialog = true" text>
                  {{ $t("login.messages.password.recover") }}?
                </v-btn>
              </v-card-actions>
            </v-form>
            <v-dialog v-model="dialog" width="500">
              <v-card style="border-radius:18px">
                <v-container
                  style="height:100%"
                  class="d-flex justify-center align-center flex-column"
                >
                  <v-card-title
                    style="word-break:normal"
                    class="d-flex justify-center text-center headline lighten-2 text-uppercase"
                    primary-title
                  >
                    {{ $t("login.messages.password.recover") }}
                  </v-card-title>

                  <v-card-text class=" mt-4 text-center ">
                    <v-text-field
                      v-model="loginForm.email"
                      :label="$t('login.email')"
                    ></v-text-field>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      :x-large="$vuetify.breakpoint.mdAndUp"
                      rounded
                      color="primary"
                      @click="fogorPassword"
                    >
                      {{ $t("login.messages.password.send") }}
                    </v-btn>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-container>
              </v-card>
            </v-dialog>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
import { auth } from "@/plugins/db";
export default {
  props: {
    source: String
  },
  data() {
    return {
      valid: false,
      emailRules: [
        v => !!v || this.$t("login.messages.email.required"),
        v => /.+@.+\..+/.test(v) || this.$t("login.messages.email.valid")
      ],
      passwordRules: [
        v => !!v || this.$t("user.messages.password.required"),
        v => (v && v.length >= 8) || this.$t("login.messages.password.valid")
      ],
      backgroundLoading: "C24615",
      password: null,
      loginForm: {},
      errors: [],
      dialog: false,
      capsHint: "",
      showPassword: false
    };
  },
  created() {},
  methods: {
    async fogorPassword() {
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      try {
        await auth.sendPasswordResetEmail(this.loginForm.email);

        this.$dialog.notify.info(this.$t("login.messages.info"), {
          position: "top-right",
          timeout: 5000
        });
        loading.close();
      } catch (error) {
        loading.close();
        return this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
      this.dialog = false;
    },
    async onSubmit(ev) {
      ev.preventDefault();
      if (this.$refs.form.validate()) {
        const loading = this.$vs.loading({
          background: "#730D0B",
          color: "rgb(255, 255, 255)",
          opacity: 1,
          type: "square"
        });
        this.loginForm.email = this.loginForm.email.toLowerCase();
        try {
          let data = await this.$store.dispatch("auth/SIGN_IN", this.loginForm);
          this.uid = data.user.uid;
          await this.$store.dispatch("auth/TRAER_USUARIO", data.user.uid);

          loading.close();

          this.$router.push({ path: "/" });
        } catch (error) {
          loading.close();

          this.$dialog.notify.error(error.message, {
            position: "top-right",
            timeout: 5000
          });
        }
      }
    },
    capson: function(event) {
      if ("getModifierState" in event) {
        if (event.getModifierState("CapsLock")) {
          this.capsHint = "CAPSLOCK ON";
        } else {
          this.capsHint = "";
        }

        if (event.key == "Enter") {
          this.onSubmit(event);
        }
      }
    }
  }
};
</script>

<style></style>
